module.exports = __webpack_public_path__ + "static/media/h04.bb5079bb.webp";